/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import NumberUtil from "../../Utils/NumberUtil";

export function erstelleImgSrc(contentType: string, daten: string | number[]) {
    const base64EncodedData = typeof daten === "string" ? daten : NumberUtil.toBase64String(daten);
    return `data:${contentType};base64,${base64EncodedData}`;
}